import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAppDispatch } from "@/redux/hooks";
import { setBottomSheet } from "@/redux/slice/themeSlice";

export default function BottomSheet({
  children,
  isOpen,
  onChange,
  classsName,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  classsName?: string;
  onChange: (value: boolean) => void;
}) {
  const [openState, setOpenState] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setOpenState(isOpen);
    dispatch(setBottomSheet(isOpen));
  }, [isOpen]);

  useEffect(() => {
    return () => {
      dispatch(setBottomSheet(false));
    };
  }, [])

  const handleOpen = () => {
    setOpenState(true);
    onChange(true);
  };

  const handleClose = () => {
    setOpenState(false);
    onChange(false);
  };

  // ref for the bottom sheet container
  const bottomSheetRef = useRef(null);

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          // onChange(false);
          setOpenState(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(bottomSheetRef);
  return (
    <>
      {/* Activator */}
      {/* <div
        className="w-fit items-center cursor-pointer gap-3 pr-2"
        onMouseUp={() => {
          handleOpen();
        }}
      >
        <BiSmile width={18} height={18} />
      </div> */}

      {/* Bottom Sheet */}
      <AnimatePresence initial={false}>
        {openState && (
          <>
            {/* Bottom Sheet */}
            <motion.div
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { y: 0, height: "auto" },
                collapsed: { y: "100%", height: 0 },
              }}
              transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
              className="fixed bottom-0 right-0 left-0 z-[20000] w-full rounded-t-3xl -gray-50 bg-outbackground-main shadow-[0px_-8px_20px_-6px_rgba(0,0,0,0.3)]"
            >
              <div
                ref={bottomSheetRef}
                className={`scrollbar max-h-[60vh] w-full p-[24px] pt-[36px] pb-[30px] overflow-y-scroll ${classsName}`}
              >
                <div className="flex flex-col">{children}</div>
              </div>
            </motion.div>

            {/* Scrim */}
            <motion.div
              key="scrim"
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={{
                visible: { opacity: 0.9 },
                hidden: { opacity: 0 },
              }}
              transition={{ duration: 0.4 }}
              className="fixed top-0 right-0 bottom-0 left-0 bg-outbackground-main opacity-50 z-50"
              onClick={handleClose}
            />
          </>
        )}
      </AnimatePresence>
      <style jsx>{`
        /* Hide scrollbar for Chrome, Safari and Opera */
        .scrollbar::-webkit-scrollbar {
          display: none;
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        .scrollbar {
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        }
      `}</style>
    </>
  );
}
